export const environment = {
  production: false,
  debug: true,
  apiURl: 'https://dev-groupsales.service.3ddigitalvenue.com',
  apiUrl: 'https://dev-groupsales.service.3ddigitalvenue.com/bo',
  sessionCookieDomain: '.3ddigitalvenue.com',
  oneLogin: {
    clientId: 'fe13a090-5691-013f-dd70-00c79bed649139188',
    issuer: 'https://3ddigitalvenue.onelogin.com/oidc/2',
    redirectUri: `${globalThis.location.origin}/auth/callback`,
    scopes: 'openid profile email',
  },
  servicesPortalUrl: 'https://dev-private.3ddigitalvenue.com',
  allowLocalOneLoginLogin: false,
  serviceTier: 'dev' as 'local' | 'dev' | 'pre' | 'prod',
  serviceIconBaseUrl: 'https://dev-workspace.3ddigitalvenue.com',
};
